import {
  DataGrid,
  type DataGridProps,
  type GridValidRowModel,
} from '@mui/x-data-grid';

import appDataGridSx from './dataGridSx';

const AppDataGrid = <R extends GridValidRowModel = GridValidRowModel>({
  sx,
  initialState,
  pageSizeOptions = [5, 10, 25],
  ...props
}: DataGridProps<R>) => (
  <DataGrid
    autoHeight
    disableRowSelectionOnClick
    rowHeight={58}
    columnHeaderHeight={46}
    pageSizeOptions={pageSizeOptions}
    {...props}
    initialState={{
      ...initialState,
      pagination: {
        ...initialState?.pagination,
        paginationModel: {
          pageSize: 5,
          ...initialState?.pagination?.paginationModel,
        },
      },
    }}
    sx={[appDataGridSx, ...(Array.isArray(sx) ? sx : [sx])]}
  />
);

export default AppDataGrid;
